import React, {useState,useEffect,useContext} from 'react'
import downArrow from "../images/orgarrow.svg";
import { useNavigate } from "react-router-dom";
import arrow from '../images/thinArrow.png'
import checkmarkGreen from '../images/checkmark-green.png';
import checkmarkRed from '../images/checkmark-red.png'
import calendar from '../images/Icon-Calendar.png'
import { keyContext } from "../components/KeyContext";
import moment from 'moment';
import NewsletterDivSent from '../components/NewsletterDivSent';
import NoteModal from '../components/Modals/NoteModal';

function SentNewsletter() {

   const key = sessionStorage.getItem("key");
   const [bios, setBios] = useState([{}]);
   const navigate = useNavigate();
   const [orgID, setOrgID] = useState();
   const [chosenBio, setchosenBio] = useState(sessionStorage.getItem('newsletter_bio') ? sessionStorage.getItem('newsletter_bio') : '');
   const [newsletters, setNewsletters] = useState([]);
   
 let ge = sessionStorage.getItem('newsletter_bio')
   let news_orgs = ge?.split(" ")[ge.split(" ").length - 1]
  

    useEffect(() => {
       if(bios.length === 1) {
          setOrgID(bios[0].No)
       }
     }, [bios]);

     useEffect(() => {
       
     if(sessionStorage.getItem('newsletter_bio')) {
      let ge = sessionStorage.getItem('newsletter_bio')
      setOrgID(ge.split(" ")[ge.split(" ").length - 1])
 
     }
  }, []);
    // get organizers fetch
     useEffect(() => {
        const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
        if (key) {
          fetch(endpoint, {
            method: "GET",
            headers: {
              ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
            },
          })
            .then((res) => {
              if (res.status !== 200) {
                navigate("/");
              }
              return res.json();
            })
            .then((result) => {
              // console.log(result)
              setBios(result);
    
              // console.log('biograf length',result.length)
              if (result.length === 1) {
              }
              // setMovieNumber(result.map((number) => number.No));
            });
        }
      }, [key]);

       const handleSelect = (e) => {
      let g = e.target.value;
        setchosenBio(e.target.value);

 
    setOrgID(g.split(" ")[g.split(" ").length - 1]);
   sessionStorage.setItem('newsletter_bio',e.target.value)
  };


   
      // existing templates fetch
       useEffect(() => {
          if(key && (orgID || news_orgs)) { 
      
          const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_get?Key=${key}&OrgNo=${news_orgs ? news_orgs : orgID}`;
           fetch(endpoint, {
              method: "GET",
              headers: {
                ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
              },
            
            })
            .then(res => {    
             return res.json()
            })
            .then(result => {
               setNewsletters(result)
             
            })
             }
        }, [key,orgID]);
 

     const svg = ` <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>`
  
           

  return (
    <div className='sentNewsletter'> 
    
      <p className='newsletter_title'>Udsendte nyhedsbreve</p>
         <label htmlFor="" style={{fontSize:'18px',fontWeight:700,letterSpacing:'0.36px',color:'#46484c',marginBottom:'11px',marginTop:'30px'}}>Biograf</label>
         <div className="movieListBox" style={{width: "384px",}}> 
     
          <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',width:'0.5px'}}></span>
          <select   className="form-select text-truncate"
                  value={chosenBio}
                  onChange={handleSelect}
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    color:'#46484c',
                   // backgroundColor: "#f7f7f7",
                     backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,
                  }}
                >
                 {bios &&
                    bios?.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            maxWidth:'380px',
                            marginLeft: "10px",
                            fontSize: "16px",width:'370px'
                          }}
                        >
                          {item.City} - {item.Name}
                        </option>
                      );
                    })}
          </select>
        </div>
        {newsletters.length ? 
        <div className='newsMailHeader' style={{gridTemplateColumns:'1fr 1fr 1fr 1fr 0.2fr'}}> 
          <p style={{alignContent:'center',margin:0,}}>Navn på nyhedsmail</p>
          <p style={{alignContent:'center',margin:0,}}>Segment</p>
          <p style={{alignContent:'center',margin:0,}}>Udsendelsesdato</p>
          <p style={{alignContent:'center',margin:0,}}> Tidspunkt</p>     
          <p style={{alignContent:'center',margin:0,width:'50px'}}></p>
        </div>
        : ''}
        { newsletters.map((newsletter) => {
         if(moment(newsletter.Sendt).format('YYYY') !== '1900')
          return  <NewsletterDivSent newsletter={newsletter} orgID={orgID} />
      
        })}
      

    </div>
  )
}

export default SentNewsletter